
import Interface from '../../lib'
const user = {
    state: {
        isLogin: false,
        userInfo: null,  // 用户信息
        cardInfo: null,  // 当前健康卡信息
        userName: null,
        sex: null,
        sexId: null,
        domicilePlace: null,
        id: null,
        idCard: null,
        mobileNumber: null,
        residence: null

    },
    mutations: {
        setIsLogin(state, data){
            state.isLogin = data;
        },
        // 用户信息
        setUserInfo(state, data){
            state.userInfo = data;
        },
        // 健康卡信息
        setCardInfo(state, data){
            state.cardInfo = data;
            if (data) {
                sessionStorage.setItem("hisCardInfo",  JSON.stringify(data));
            } else {
                sessionStorage.setItem("hisCardInfo",  'null');
            }
        },
        setUserName(state, data){
            state.userName = data;
        },
        setSex(state, data){
            state.sex = data;
        },
        setSexId(state, data){
            state.sexId = data;
        },
        setDomicilePlace(state, data){
            state.domicilePlace = data;
        },
        setId(state, data){
            state.id = data;
        },
        setIdCard(state, data){
            state.idCard = data;
        },
        setMmobileNumber(state, data){
            state.mobileNumber = data;
        },
        setResidence(state, data){
            state.residence = data;
        }
    },
    actions: {
        loginInfo({ commit, state }){
            Interface.pma.my.GetSessionId().then(res => {
                Interface.pma.my.QueryUser(res.data).then(res => {
                    console.log('loginInfo', res.data.data);
                    let data = res.data.data
                    sessionStorage.setItem("userInfo", JSON.stringify(data));  //添加到sessionStorage
                    sessionStorage.setItem("isLogin", true);  //添加到sessionStorage
                    Interface.pma.my.GetBindHealthCard(data.Id).then(res => {
                        // console.log('健康卡', res);
                        if (res.data.code == 200) {
                            if ( res.data.data.length > 0) {
                                let cardList = res.data.data;
                                let cardInfo = cardList[0];
                                // sessionStorage.setItem("hisCardInfo", JSON.stringify(cardInfo));  //添加到sessionStorage
                                console.log('登录cardInfo', cardInfo)
                                commit('setCardInfo', cardInfo)
                            } else {
                                // sessionStorage.setItem("hisCardInfo", '');  //添加到sessionStorage
                                commit('setCardInfo', null)
                            }
                        }
                    }).catch(err => {
                        console.log('健康卡 err', err);
                        commit('setCardInfo', null)
                    });

                    commit('setIsLogin', true)
                    commit('setUserInfo', data)
                    commit('setUserName', data.UserName)
                    commit('setSex', data.Sex)
                    commit('setSexId', data.SexId)
                    commit('setDomicilePlace', data.DomicilePlace)
                    commit('setId', data.Id)
                    commit('setIdCard', data.IdCard)
                    commit('setMmobileNumber', data.MobileNumber)
                    commit('setResidence', data.Residence)
                });
                // console.log(res);
            }).catch(err => {
                console.log('loginInfo err', err);
            });
        },
        getInfo({ commit, state }){
            let data = JSON.parse(sessionStorage.getItem("userInfo"))
            // console.log('getInfo', data);
            commit('setUserInfo', data)
            commit('setUserName', data.UserName)
            commit('setSex', data.Sex)
            commit('setSexId', data.SexId)
            commit('setDomicilePlace', data.DomicilePlace)
            commit('setId', data.Id)
            commit('setIdCard', data.IdCard)
            commit('setMmobileNumber', data.MobileNumber)
            commit('setResidence', data.Residence)
            
            console.log('hisCardInfo', sessionStorage.getItem("hisCardInfo"))
            if(sessionStorage.getItem("hisCardInfo") != 'null' || sessionStorage.getItem("hisCardInfo") != 'undefined'){
                let cardInfo = JSON.parse(sessionStorage.getItem("hisCardInfo"))
                commit('setCardInfo', cardInfo)
            } else {
                commit('setCardInfo', null)
            }
        }
    }
    
}
export default user


// WEBPACK FOOTER //
// ./src/store/modules/user.js